const STEPS = [
  {
    n: '01',
    title: 'Two Weeks, Not Two Years',
    desc: "Don't buy a bunker. Get 14 days of water, food, and a way to charge a phone. That alone covers most real emergencies.",
  },
  {
    n: '02',
    title: 'Know Your Actual Risks',
    desc: 'A hurricane coast, a wildfire canyon, and a winter-storm interior all need different plans. Read the region playbook for where you live.',
  },
  {
    n: '03',
    title: 'Practice Once, Not Never',
    desc: 'Run your plan for a weekend before you need it for real: cook on the backup stove, run the generator, read the compass.',
  },
]

// A short, real beginner path — not the full dedicated onboarding page yet
// (see the IA in Original Savage SEO Roadmap.md), but a genuine destination
// for the header/hero "Start Here" link instead of a dead anchor.
export default function StartHere() {
  return (
    <section className="wrap sec" id="start">
      <div className="sec-head">
        <div>
          <div className="idx">
            NEW HERE &middot; <b>START IN 3 STEPS</b>
          </div>
          <h2>Your First 30 Days</h2>
        </div>
        <a className="link-more" href="#guides">
          Full Knowledge Base &rarr;
        </a>
      </div>
      <div className="pillars">
        {STEPS.map((s, i) => (
          <a className="pill" href="#guides" key={s.n} style={i === STEPS.length - 1 ? { gridColumn: '1 / -1' } : undefined}>
            <span className="num">{s.n}</span>
            <span className="pc">
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </span>
            <span className="arw" aria-hidden="true">
              &rarr;
            </span>
          </a>
        ))}
      </div>
    </section>
  )
}
